import React from 'react';
import PropTypes from 'prop-types';
import { Price, Lozenge } from './';

function Sides({ side, allsides, toggle, title }) {
    const record = new Set();

    return (
        <>
            <h4 className='opener' onClick={toggle}>
                {title}
            </h4>
            <div className='panel'>
                {side.map(
                    (
                        { displayName, slug, fulfilmentTypes, price, plu, lozenge },
                        idx
                    ) => {
                        if (fulfilmentTypes.length && !record.has(plu)) {
                            record.add(plu);
                            return (
                                <p key={`sides-${idx}`}>
                                    {displayName}
                                    {price && price.value ? (
                                        <span className='price'>
                                            <Price price={price} naked={true} />
                                        </span>
                                    ) : null}
                                    <Lozenge lozenge={lozenge} isForSide={true} />
                                </p>
                            );
                        }
                        return null;
                    }
                )}
            </div>
        </>
    );
}

Sides.propTypes = {
    allsides: PropTypes.array,
    side: PropTypes.array,
    title: PropTypes.string,
    toggle: PropTypes.func
};

export { Sides };
